module.exports = __webpack_public_path__ + "static/media/shop.3ba8d7b2.jpg";